module.exports = __webpack_public_path__ + "static/media/copy.83c4b407.svg";